export default __webpack_public_path__ + "1ff5e741ab6ce1cb9ee6c52e9a21cf27.jpg";